(function($) {

    var isIE = document.body.style.msTouchAction !== undefined;

    $(document).ready(function () {

        if ($('.project-gallery-swiper').length && $('.project-gallery-swiper-text').length) {
            var projectSliderImages = new Swiper ('.project-gallery-swiper', {
                slidesPerView: 2,
                allowTouchMove: false,
                speed: 1000,
                effect: 'fade',
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 2
                },
                fadeEffect: {
                    crossFade: true
                }
            });

            projectSliderImages.on('lazyImageReady', function(slideEl, imageEl) {
                if (!isIE) {
                    imageEl.onload = function() {
                        imageEl.classList.add('swiper-lazy-loaded-visible');
                        $(imageEl).parent().addClass('reveal');
                    }
                }
                else {
                    imageEl.classList.add('swiper-lazy-loaded-visible');
                    $(imageEl).parent().addClass('reveal');
                }
            });

            var projectSliderText = new Swiper ('.project-gallery-swiper-text', {
                controller: {
                    control: projectSliderImages,
                },
                slidesPerView: 1,
                allowTouchMove: true,
                speed: 600,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: '.project-gallery-swiper-text .swiper-pagination',
                    type: 'bullets',
                },
                navigation: {
                    nextEl: '.project-gallery-swiper-text .swiper-button-next',
                    prevEl: '.project-gallery-swiper-text .swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 680
                    680: {
                        allowTouchMove: false,
                        pagination: {
                            el: '.project-gallery-swiper-text .swiper-pagination',
                            type: 'fraction',
                        },
                    }
                }
            });

            $('.project-gallery .scroll-down').on('click', function() {
               var nextSection = $('.project-gallery').next().offset().top - $('header').outerHeight();

                $('html, body').animate({ scrollTop: nextSection }, '350');
            });

            $(window).on('resize', function() {
                projectSliderText.pagination.render();
                projectSliderText.pagination.update();
            });
        }

    });

})( jQuery );